/* eslint-disable import/no-anonymous-default-export */
import dashboard from './dashboard.json';
import orderReport from './order-report.json';
import productReport from './product-report.json';
import categories from './categories.json';
import collections from './collection.json';
import promotionSystem from './promotion-system.json';

export default {
  dashboard,
  orderReport,
  productReport,
  categories,
  collections,
  promotionSystem
};
